export default {
  LOADING_GET_BALANCE: 'LOADING_GET_BALANCE',
  SUCCESS_GET_BALANCE: 'SUCCESS_GET_BALANCE',
  ERROR_GET_BALANCE: 'ERROR_GET_BALANCE',

  LOADING_GET_WALLETS: 'LOADING_GET_WALLETS',
  SUCCESS_GET_WALLETS: 'SUCCESS_GET_WALLETS',
  ERROR_GET_WALLETS: 'ERROR_GET_WALLETS',

  LOADING_GET_CURRENCIES: 'LOADING_GET_CURRENCIES',
  SUCCESS_GET_CURRENCIES: 'SUCCESS_GET_CURRENCIES',
  ERROR_GET_CURRENCIES: 'ERROR_GET_CURRENCIES',

  LOADING_GET_WALLET_CONFIGURATION: 'LOADING_GET_WALLET_CONFIGURATION',
  SUCCESS_GET_WALLET_CONFIGURATION: 'SUCCESS_GET_WALLET_CONFIGURATION',
  ERROR_GET_WALLET_CONFIGURATION: 'ERROR_GET_WALLET_CONFIGURATION',

  LOADING_GET_TRANSACTIONS: 'LOADING_GET_TRANSACTIONS',
  SUCCESS_GET_TRANSACTIONS: 'SUCCESS_GET_TRANSACTIONS',
  ERROR_GET_TRANSACTIONS: 'ERROR_GET_TRANSACTIONS',

  UPDATE_TRANSACTIONS_FILTERS: 'UPDATE_TRANSACTIONS_FILTERS',

  MASS_PAYMENTS_CREATED: 'SIGNALR_INCOME/ReceiveMessage/BatchWithdrawalTransactionsCreated',
  MASS_PAYMENTS_COPMLETED: 'SIGNALR_INCOME/ReceiveMessage/WithdrawalBatchTransactionsProcessed',

  LOADING_GET_PAYMENT_CARD: 'LOADING_GET_PAYMENT_CARD',
  SUCCESS_GET_PAYMENT_CARD: 'SUCCESS_GET_PAYMENT_CARD',
  ERROR_GET_PAYMENT_CARD: 'ERROR_GET_PAYMENT_CARD',
} as const;
